import { render, staticRenderFns } from "./general-tabbed-content.vue?vue&type=template&id=5ea6cc5c&scoped=true&"
import script from "./general-tabbed-content.vue?vue&type=script&lang=js&"
export * from "./general-tabbed-content.vue?vue&type=script&lang=js&"
import style0 from "./general-tabbed-content.vue?vue&type=style&index=0&id=5ea6cc5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea6cc5c",
  null
  
)

export default component.exports